export default __webpack_public_path__ + "static/media/location_gray.4afa6e82.svg";